/**
 * TabButton Component for UI-Model-1
 *
 * Vertical navigation tab button with icon and label
 */

import React, { useState } from 'react';
import {
  CustomCssIconSelected,
  LayoutUIModelIconSelected,
  ThemeIconSelected,
} from 'assests/GmsIcons';
import { TabButtonProps } from '../../types/navigation.types';

const getSelectedIcon = (label: string) => {
  switch (label) {
    case 'Layout':
      return <LayoutUIModelIconSelected />;
    case 'Theme':
      return <ThemeIconSelected />;
    case 'Custom CSS':
      return <CustomCssIconSelected />;
    default:
      return null;
  }
};

export const TabButton = ({
  id,
  icon,
  label,
  isActive,
  onClick,
  className = '',
}: TabButtonProps) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      id={id}
      data-testid={id}
      className={`
        tw-flex tw-flex-col tw-items-center tw-justify-center
        tw-w-full tw-py-2
        tw-transition-colors tw-duration-200
        ${
          isActive
            ? 'tw-text-accent-bold tw-font-semibold'
            : `tw-text-ink-tertiary tw-font-normal ${isHovered ? 'hover:tw-text-accent-bold hover:tw-font-semibold' : ''}`
        }
        ${className}
      `}
      onClick={onClick}
      title={label}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className={`tw-p-1 tw-rounded-md [&_path]:tw-stroke-current icon-fill-current ${
          isActive ? 'tw-bg-surface-hover' : isHovered ? 'tw-bg-surface-hover' : 'tw-bg-transparent'
        }`}
      >
        {isActive || isHovered ? getSelectedIcon(label) : icon}
      </div>
      <span className="tw-text-xs tw-mt-1">{label}</span>
    </button>
  );
};

export default TabButton;
